import React from 'react';
import TwoDashes from 'Components/TwoDashes';
import { Popover, Button } from '@brighterion/br-ui';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import styles from './LinkedRulesCount.css';

type Props = {
    deployedRules?: LinkedDeployedRules;
    sandboxRules?: LinkedSandboxRules;
};

const LinkedRulesCount = ({ deployedRules, sandboxRules }: Props) => {
    const { t } = useTranslation();
    const uniqueRules = _.uniq([...(deployedRules || []), ...(sandboxRules || [])]);
    const totalLinkedRules = uniqueRules.length;

    if (totalLinkedRules === 0) {
        return <TwoDashes />;
    }

    return (
        <div className={styles.linkedRules}>
            <Popover
                contentClassName={styles.popperContentCls}
                popperClassName={styles.popperClassName}
                showCopy
                showOnHover
                showArrow
                content={uniqueRules.join(', ')}
                copiedMessage={t('rulesIdCopied', { count: totalLinkedRules })}
                containerDivProps={{
                    // TS doesn't seem to like us adding data props
                    // @ts-ignore
                    'data-ignore-on-row-interact': true
                }}
            >
                <Button
                    data-ignore-on-row-interact='true'
                    size='small'
                    variant='tertiary'
                    className={styles.linkedRulesBtn}
                >
                    {t('linkedRules', { count: totalLinkedRules })}
                </Button>
            </Popover>
        </div>
    );
};

export default React.memo(LinkedRulesCount);
